/**
 * Modal
 */

const modals = [...document.querySelectorAll('.js-modal')]
const openHandlers = [...document.querySelectorAll('.js-open-modal')]
const closeHandlers = [...document.querySelectorAll('.js-close-modal')]

export default () => {
  if (!modals.length) return
  // Bind open handlers
  openHandlers.forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      const { target } = el.dataset
      open(target)
    })
  })

  modals.forEach(modal => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeAll()
    })
  })

  closeHandlers.forEach(close => {
    close.addEventListener('click', (e) => {
      closeAll()
      e.preventDefault()
    })
  })
}

export const open = (id) => {
  closeAll()
  document.getElementById(id).classList.add('o-modal--is-active')
}

export const closeAll = () => {
  modals.forEach(modal => {
    modal.classList.remove('o-modal--is-active')
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Modal.js